import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-popupsuccesscard',
  templateUrl: './popupsuccesscard.component.html',
  styleUrls: ['./popupsuccesscard.component.scss']
})
export class PopupsuccesscardComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,  public dialogRef: MatDialogRef<PopupsuccesscardComponent>,) { }

  message1:any;
  message2:any;

ngOnInit(){
  this.message1=this.data.message1
  this.message2=this.data.message2

}
  onConfirm() {
    // Close the dialog or execute additional actions
    console.log('Dialog confirmed');
    this.dialogRef.close()
  }
}
